/**
 * The base breakpoints for the  PRO React.
 * You can add new breakpoints using this file.
 * You can customized the breakpoints for the entire  PRO React using thie file.
 */

const breakpoints = {
  values: {
    xs: 0,
    sm: 680,
    md: 900,
    lg: 1400,
    xl: 1750,
    xxl: 2050,
  },
};

export default breakpoints;
